import React from "react"
import JumboHeader from "@components/jumbo-header"

export default ({ title, asset }) => (
  <div className="container">
    <div className="row">
      <div className="col-xs-12">
        <div className={!!asset ? "panel" : "content-feed-header"}>
          <JumboHeader
            title={title}
            media={
              asset && {
                default: asset.full,
                "767px": asset.w970,
                "460px": asset.w460,
              }
            }
          />
        </div>
      </div>
    </div>
  </div>
)
